import {
    MDBListGroup, MDBListGroupItem, MDBBadge,
    MDBInput
    , MDBInputGroup
    , MDBRow, MDBCol
    , MDBIcon
    , MDBTextArea
    , MDBTimepicker
    , MDBDatepicker
    , MDBSelect
    , MDBAutocomplete
    , MDBBtn
}
    from 'mdb-react-ui-kit';
import React, { forwardRef, useImperativeHandle, useEffect, useState, useRef } from "react";
import moment from 'moment';
import Helper from '../../Helper';

const JobDetail = forwardRef((props, ref) => {
    const [mode, setMode] = useState(props.mode || 'add');
    const [selectCustomer, setSelectCustomer] = useState(props.job?.customerid || 0);
    const [selectpaidby, setselectpaidby] = useState(props.job?.paidbyid || 1);
    const [boxsize, setboxsize] = useState(props.job?.boxsize );
    const [driver, setdriver] = useState(props.job?.driver);
    const [lcplate, setlcplate] = useState(props.job?.lcplate);
    const [Customers, SetCustomers] = useState([{ text: '', value: 0 }, ...props.customers]);
    const [jobs, setJobs] = useState([]);
    const [searchlist, setSearchlist] = useState({});
    const [masterlist, setMasterlist] = useState({});
    const [addressSelected, setAddressSelected] = useState({});
    const [jobslist, setJobslist] = useState([]);
    const [pickup, setPickup] = useState(props.job?.pickuplocation || '');
    const [pickuplist, setPickuplist] = useState([]);
    const [paidbylist, setpaidbylist] = useState([
        { text: 'บริษัท', value: 1 },
        { text: 'เครดิต', value: 2 },
        { text: 'เงินสด', value: 3 }
    ]);
    const [job, setJob] = useState(props.job?.jobname || '');
    const componentList = ["jobdate", "driver", "lcplate", "jobname", "pickuplocation", "destination", "bl", "amount", "boxno", "boxsize", "returnboxduration", "returnboxdestination"
        , "receiptaddress1", "receiptaddress2", "receiptaddress3", "receiptaddress4"
    ]
    const onSearch = (value) => {
        setJobs(jobslist.filter((item) => item.text.toLowerCase().startsWith(value.toLowerCase())));
    }
    const onSearchMaster = (value, master) => {
        var list = { ...masterlist };
        if (list[master]) {
            list[master] = list[master].filter((item) => item.text.toLowerCase().startsWith(value.toLowerCase()))

            setSearchlist({ ...list })
        }
    }
    const getJobs = async (customerId) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getJobs/` + customerId, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${Helper.gettoken()}`,
                    'Content-Type': 'application/json',
                },
            });
            const data = await response.json();
            if (response.ok) {

                setJobslist(data.result);
            } else {

                setError(data.message || 'Failed to fetch Job list');
            }
        } catch (err) {
            setError('An error occurred while fetching the Job list.');
        }
    };

    const getMaster = async (master, list) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getitem/${master}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${Helper.gettoken()}`,
                    'Content-Type': 'application/json',
                },
            });
            const data = await response.json();
            if (response.ok) {
                return data.result

            } else {

                setError(data.message || 'Failed to fetch master list');
            }
        } catch (err) {
            setError('An error occurred while fetching the master list.');
        }
    };

    const _getAddress = (address) => {
        return document.getElementById(mode + "receipt" + address)?.value;
    }
    const _getResult = (exclude) => {
        const listItem = [];
        for (var a of componentList.filter(e => e != exclude)) {
            listItem.push({
                name: a,
                value: document.getElementById(mode + a).value,

            })
        }

        listItem.push({
            name: "customerid",
            value: selectCustomer,

        })
        listItem.push({
            name: "customername",
            value: props.customers.find(el => el.value == selectCustomer)?.text,

        })

        if(document.getElementById(mode + "driver").value != ''){
        const selecteddriver = Customers.find(el => el.name_alt == document.getElementById(mode + "driver").value && el.isdriver ==1)
        if (selecteddriver) {
            listItem.push({
                name: "driverid",
                value: selecteddriver.driverid,

            });
            listItem.push({
                name: "drivercustomerid",
                value: selecteddriver.value,

            });
            listItem.push({
                name: "driverfullname",
                value: selecteddriver.text,

            });
        }
    }

        listItem.push({
            name: "paidbyid",
            value: selectpaidby,

        })
        listItem.push({
            name: "paidby",
            value: paidbylist.find(el => el.value == selectpaidby)?.text,

        })

        const obj = listItem.reduce((acc, current, index) => {
            acc[current.name] = current.value;
            return acc;
        }, {});
        return obj;
    }
    const setError = (message) => props.setError?.apply(this, [message]);
    const addNewAddress = (address, e) => {
        props.addNewAddress?.apply(this, [address, e]);
    }


    useImperativeHandle(ref, () => ({
        getResult: () => {

            return _getResult();
        },
        getAddress: (address) => {

            return _getAddress(address);
        },
        updateList: () => {
            getlist();
        },
        checkvalidField: () => {

        }
    }))
    const updatedAddress = (e) => {
        e.currentTarget.data = undefined;
        var addressSelected = {};
        for (var i = 1; i <= 4; i++) {
            addressSelected["address" + i] = document.getElementById(mode + "receiptaddress" + i).data;
        }
        setAddressSelected(addressSelected);
    }
    const getlist = async () => {
        var list = {};
        var masterlist = ["Pickup", "driver", "licenseplate", "boxsize", "address1", "address2", "address3", "address4"];
        for (var item of masterlist) {

            var result = await getMaster(item);
            if (result) {
                list[item] = result;
            }
        }
        setMasterlist({ ...list });

    }
    useEffect(() => {
        getlist();

    }, []);

    return (<>


        <MDBRow className="mt-3">
            <MDBCol md="4">

                <MDBInputGroup textBefore='วันที่' className='mb-3 dropdown-group'>
                    <MDBDatepicker inputToggle inline id={mode + "jobdate"} inputLabel="เลือกวันที่" defaultValue={moment(props.job?.jobdateobj).format('DD/MM/YYYY') || props.job?.jobdate || moment().format('DD/MM/YYYY')} />
                </MDBInputGroup>

            </MDBCol>
            <MDBCol md="2">

                <MDBInputGroup textBefore='จ่าย' className='mb-3 dropdown-group'>
                    <MDBSelect

                        data={paidbylist}
                        value={selectpaidby}
                        onChange={(e) => {
                            setselectpaidby(e.value);
                        }}
                    />
                </MDBInputGroup>

            </MDBCol>
            <MDBCol md="6">

                <MDBInputGroup textBefore='คนรถ' className='mb-3 dropdown-group'>
                    <MDBAutocomplete
                        displayValue={(row) => row.name_alt}
                        data={Customers.filter(e=>e.isdriver ===1)}
                        label='เลือกหรือพิมพ์เพื่อใส่อื่นๆ'
                        id={mode + "driver"}
                        onSearch={(value) => onSearchMaster(value, "driver")}
                        value={driver}
                        onChange={(driver) => setdriver(driver)}
                        noResults={"ไม่พบข้อมูล"}
                    />

                    <span className='input-group-text'>ทะเบียน</span>

                    <MDBAutocomplete
                        displayValue={(row) => row.text}
                        data={searchlist["licenseplate"]}
                        label='เลือกหรือพิมพ์เพื่อใส่อื่นๆ'
                        id={mode + "lcplate"}
                        onSearch={(value) => onSearchMaster(value, "licenseplate")}
                        value={lcplate}
                        onChange={(lcplate) => setlcplate(lcplate)}
                        noResults={"ไม่พบข้อมูล"}
                    />
                </MDBInputGroup>

            </MDBCol>
        </MDBRow>
        <MDBRow className="mt-2">
            <MDBCol md="12">

                <MDBInputGroup textBefore='ผู้ว่าจ้าง' className='mb-3 dropdown-group'>

                    <MDBSelect style={{ minWidth: "500px" }}
                        disabled={props.disabledCustomer}
                        search
                        data={Customers}
                        displayValue={(row) => row.name}
                        label='ผู้ว่าจ้าง'
                        value={selectCustomer}
                        onChange={(e) => {
                            if (!e || e.value === 0) return;
                            setSelectCustomer(e.value);
                            getJobs(e.value);
                        }}
                    />

                    <span className='input-group-text'>งาน</span>

                    <MDBAutocomplete
                        displayValue={(row) => row.text}
                        data={jobs}
                        label='เลือกหรือพิมพ์เพื่อใส่อื่นๆ'
                        id={mode + "jobname"}
                        onSearch={onSearch}
                        value={job}
                        noResults={"ไม่พบข้อมูล"}
                        onChange={(job) => setJob(job)} />
                </MDBInputGroup>

            </MDBCol>
            <MDBCol md="6">

                <MDBInputGroup textBefore='สถานที่รับ' className='mb-3 dropdown-group'>
                    <MDBAutocomplete
                        displayValue={(row) => row.text}
                        data={searchlist["Pickup"]}
                        label='เลือกหรือพิมพ์เพื่อใส่อื่นๆ'
                        id={mode + "pickuplocation"}
                        onSearch={(value) => onSearchMaster(value, "Pickup")}
                        value={pickup}
                        noResults={"ไม่พบข้อมูล"}
                        onChange={(pickup) => setPickup(pickup)} />

                </MDBInputGroup>

            </MDBCol>
            <MDBCol md="6">

                <MDBInputGroup textBefore='สถานที่จัดส่ง' className='mb-3'>

                    <input className='form-control' type='text' id={mode + "destination"} defaultValue={props.job?.destination} />
                </MDBInputGroup>

            </MDBCol>
            <MDBCol md="12">

                <MDBInputGroup textBefore='BL:' className='mb-3 dropdown-group' >
                    <input className='form-control' type='text' id={mode + "bl"} defaultValue={props.job?.bl} disabled={props.disabledCustomer} />
                    <span className='input-group-text'>จำนวน</span>
                    <input className='form-control' type='text' id={mode + "amount"} defaultValue={props.job?.amount} disabled={props.disabledCustomer} />
                    <span className='input-group-text'>ขนาด</span>
                    <div style={{ width: "22em" }} className='form-outline'>
                        <MDBAutocomplete className='form-control'
                            displayValue={(row) => row.text}
                            data={searchlist["boxsize"]}
                            label='เลือกหรือพิมพ์เพื่อใส่อื่นๆ'
                            id={mode + "boxsize"}
                            onSearch={(value) => onSearchMaster(value, "boxsize")}
                            value={boxsize}
                            onChange={(boxsize) => setboxsize(boxsize)}
                            noResults={"ไม่พบข้อมูล"}
                        />
                    </div>
                    <span className='input-group-text'>เบอร์ตู้</span>
                    <input className='form-control' type='text' id={mode + "boxno"} defaultValue={props.job?.boxno} />
                </MDBInputGroup>

            </MDBCol>
            <MDBCol md="3">

                <MDBInputGroup textBefore='คืนตู้ภายใน' className='mb-3'>
                    <input className='form-control' type='number' id={mode + "returnboxduration"} defaultValue={props.job?.returnboxduration} />
                    <span className='input-group-text'>วัน</span>


                </MDBInputGroup>
            </MDBCol>
            <MDBCol md="9">
                <MDBInputGroup textBefore='สถานที่คืนตู้' className='mb-3'>
                    <input className='form-control' type='text' id={mode + "returnboxdestination"} defaultValue={props.job?.returnboxdestination} />

                </MDBInputGroup>

            </MDBCol>
            <MDBCol ms="12" className='receiptaddress'>
                <MDBInputGroup className='mb-3' textBefore='ที่อยู่ออกใบเสร็จ (1)'>
                    <MDBAutocomplete
                        className='form-control'
                        data={searchlist["address1"]}
                        displayValue={(row) => row.text}
                        label='ค้นหาที่อยู่'
                        onSearch={(value) => onSearchMaster(value, "address1")}
                        noResults={"ไม่พบข้อมูล"}
                        onSelect={(e) => {
                            document.getElementById(mode + "receiptaddress1").value = e.text;
                            document.getElementById(mode + "receiptaddress1").data = e.value;
                            addressSelected["address1"] = true;
                        }}
                    />
                    <textarea className='form-control' id={mode + "receiptaddress1"} defaultValue={props.job?.receiptaddress1} onChange={updatedAddress} />
                    {mode == "add" && !addressSelected["address1"] && <MDBBtn outline onClick={(e) => addNewAddress("address1", e)}><MDBIcon fas icon="plus" /></MDBBtn>}
                </MDBInputGroup>
                <MDBInputGroup className='mb-3' textBefore='ที่อยู่ออกใบเสร็จ (2)'>
                    <MDBAutocomplete
                        className='form-control'
                        data={searchlist["address2"]}
                        displayValue={(row) => row.text}
                        label='ค้นหาที่อยู่'
                        onSearch={(value) => onSearchMaster(value, "address2")}
                        noResults={"ไม่พบข้อมูล"}
                        onSelect={(e) => {
                            document.getElementById(mode + "receiptaddress2").value = e.text;
                            document.getElementById(mode + "receiptaddress2").data = e.value;
                            addressSelected["address2"] = true;
                        }}
                    />
                    <textarea className='form-control' id={mode + "receiptaddress2"} defaultValue={props.job?.receiptaddress2} onChange={updatedAddress} />
                    {mode == "add" && !addressSelected["address2"] && <MDBBtn outline onClick={(e) => addNewAddress("address2", e)}><MDBIcon fas icon="plus" /></MDBBtn>}
                </MDBInputGroup>
                <MDBInputGroup className='mb-3' textBefore='ที่อยู่ออกใบเสร็จ (3)'>
                    <MDBAutocomplete
                        className='form-control'
                        data={searchlist["address3"]}
                        displayValue={(row) => row.text}
                        label='ค้นหาที่อยู่'
                        onSearch={(value) => onSearchMaster(value, "address3")}
                        noResults={"ไม่พบข้อมูล"}
                        onSelect={(e) => {
                            document.getElementById(mode + "receiptaddress3").value = e.text;
                            document.getElementById(mode + "receiptaddress3").data = e.value;
                            addressSelected["address3"] = true;
                        }}
                    />
                    <textarea className='form-control' id={mode + "receiptaddress3"} defaultValue={props.job?.receiptaddress3} onChange={updatedAddress} />
                    {mode == "add" && !addressSelected["address3"] && <MDBBtn outline onClick={(e) => addNewAddress("address3", e)} ><MDBIcon fas icon="plus" /></MDBBtn>}
                </MDBInputGroup>
                <MDBInputGroup className='mb-3' textBefore='ที่อยู่ออกใบเสร็จ (4)'>
                    <MDBAutocomplete
                        className='form-control'
                        data={searchlist["address4"]}
                        displayValue={(row) => row.text}
                        label='ค้นหาที่อยู่'
                        onSearch={(value) => onSearchMaster(value, "address4")}
                        noResults={"ไม่พบข้อมูล"}
                        onSelect={(e) => {
                            document.getElementById(mode + "receiptaddress4").value = e.text;
                            document.getElementById(mode + "receiptaddress4").data = e.value;
                            addressSelected["address4"] = true;
                        }}
                    />
                    <textarea className='form-control' id={mode + "receiptaddress4"} defaultValue={props.job?.receiptaddress4} onChange={updatedAddress} />
                    {mode == "add" && !addressSelected["address4"] && <MDBBtn outline onClick={(e) => addNewAddress("address4", e)} ><MDBIcon fas icon="plus" /></MDBBtn>}
                </MDBInputGroup>
            </MDBCol>
        </MDBRow>

    </>)
});

export default JobDetail;